import { Modal } from 'antd';
import { track } from '../../../../../tracking';

export const WarningModal = (
    mainText: string,
    subText: string,
    onContinue: () => Promise<void>,
) => {
    const t = Modal.confirm({
        title: <span className="flex mr-24 text-center">{mainText}</span>,
        content: (
            <span className="flex text-14 mr-24 text-darwin-neutral-800 text-left">{subText}</span>
        ),
        okText: 'Confirm',
        cancelText: 'Cancel',
        okButtonProps: { className: 'primary-btn font-lato rounded-4' },
        cancelButtonProps: { className: 'neutral-btn font-lato rounded-4' },
        visible: true,
        className: 'rounded-8 w-400',
        width: 470,
        keyboard: true,
        closable: true,
        onOk: async () => {
            t.update({
                okButtonProps: {
                    loading: true,
                    className: 'primary-btn font-lato cursor-pointer',
                },
            });

            setTimeout(() => {
                const el: HTMLDivElement = document.getElementsByClassName(
                    'ant-modal-wrap',
                )[0] as HTMLDivElement;
                el?.focus();
            }, 200);

            await onContinue();
        },
        onCancel: (args) => {
            if (args?.triggerCancel) {
                return;
            }
            track('ON_CANCEL_IN_WARNING_MODAL');
            t.destroy();
            return;
        },
        bodyStyle: { padding: '24px' },
    });

    t.update({
        okButtonProps: { className: 'primary-btn font-lato cursor-pointer rounded-4' },
        cancelButtonProps: {
            className: 'neutral-btn font-lato cursor-pointer rounded-4',
        },
    });

    setTimeout(() => {
        const el: HTMLDivElement = document.getElementsByClassName(
            'ant-modal-wrap',
        )[0] as HTMLDivElement;
        el?.focus();
    }, 200);
};
